import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import "./steps.css";
import 'bootstrap/dist/js/bootstrap.bundle.min';


const OnboardingFAQ = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 md:pt-30 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Onboarding FAQs</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="section sofax-section-padding2  pt-65 pb-130"
          
        >
          <div className="container mt-5" bis_skin_checked={1}>
            <div
              className="row clearfix"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className="accordion block active-block">
                    <div className="acc-btn active" bis_skin_checked={1}>
                      <div className="icon-box" bis_skin_checked={1} />
                      <h4>
                        1. I'm getting a black blank screen. What should I do?
                      </h4>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: "block" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>Does your screen look something like this?</p>
                        <div className="row" bis_skin_checked={1}>
                          <div
                            className="col-6 col-md-5 col-lg-2"
                            bis_skin_checked={1}
                          >
                            <div className="cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/blankscreen1.png"
                                alt="I'm getting a black blank screen. What should I do?"
                              />
                            </div>
                          </div>
                          <div
                            className="col-6 col-md-5 col-lg-2"
                            bis_skin_checked={1}
                          >
                            <div className="cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/blankscreen2.png"
                                alt="I'm getting a black blank screen. What should I do?"
                              />
                            </div>
                          </div>
                        </div>
                        <p>
                          This means the CAMERA access to your default BROWSER
                          is denied. Please follow the steps below to Allow
                          camera access.
                        </p>
                        <ul
                          className="nav nav-pills nav-justified flex-column flex-sm-row style1"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li className="nav-item" role="presentation">
                            <a
                              className="nav-link rounded"
                              id="pills-cloud-tab"
                              data-bs-toggle="pill"
                              href="#iOS"
                              role="tab"
                              aria-controls="pills-cloud"
                              aria-selected="false"
                              bis_skin_checked={1}
                              tabIndex={-1}
                            >
                              <div
                                className="text-center py-2"
                                bis_skin_checked={1}
                              >
                                <h6 className="mb-0">iOS</h6>
                              </div>
                            </a>
                            {/*end nav link*/}
                          </li>
                          {/*end nav item*/}
                          <li className="nav-item" role="presentation">
                            <a
                              className="nav-link rounded active"
                              id="pills-smart-tab"
                              data-bs-toggle="pill"
                              href="#android"
                              role="tab"
                              aria-controls="pills-smart"
                              aria-selected="true"
                              bis_skin_checked={1}
                            >
                              <div
                                className="text-center py-2"
                                bis_skin_checked={1}
                              >
                                <h6 className="mb-0">Android</h6>
                              </div>
                            </a>
                            {/*end nav link*/}
                          </li>
                          {/*end nav item*/}
                        </ul>
                        {/*end nav pills*/}
                        <div className="row" bis_skin_checked={1}>
                          <div
                            className="col-12 mt-1 pt-1"
                            bis_skin_checked={1}
                          >
                            <div
                              className="tab-content"
                              id="pills-tabContent"
                              bis_skin_checked={1}
                            >
                              <div
                                className="tab-pane fade"
                                id="iOS"
                                role="tabpanel"
                                aria-labelledby="pills-cloud-tab"
                                bis_skin_checked={1}
                              >
                                <div
                                  className="row align-items-center"
                                  bis_skin_checked={1}
                                >
                                  <div
                                    className="col-md-12 mt-1 mt-sm-0 pt-0 pt-sm-0"
                                    bis_skin_checked={1}
                                  >
                                    <div
                                      className="full mb-1"
                                      bis_skin_checked={1}
                                    >
                                      <div
                                        className="row wow fadeInUp animated animated animated"
                                        data-wow-delay="0.4s"
                                        style={{
                                          visibility: "visible",
                                          animationDelay: "0.4s",
                                          animationName: "fadeInUp",
                                        }}
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="col-12 col-md-12 col-xs-12 offset-xs-1"
                                          bis_skin_checked={1}
                                        >
                                          <p>i. Go to Settings → Safari</p>
                                          <div
                                            className="row"
                                            bis_skin_checked={1}
                                          >
                                            <div
                                              className="col-12 col-md-5 col-lg-3"
                                              bis_skin_checked={1}
                                            >
                                              <div
                                                className="cardcss"
                                                bis_skin_checked={1}
                                              >
                                                <img
                                                  className="card-img-top"
                                                  src="https://skyipay.co.uk/assets/images/photo/apple1.png"
                                                  alt="Step1"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <p>
                                            ii. Scroll to find "Camera" under
                                            SETTINGS FOR WEBSITES section
                                          </p>
                                          <div
                                            className="row"
                                            bis_skin_checked={1}
                                          >
                                            <div
                                              className="col-12 col-md-5 col-lg-3"
                                              bis_skin_checked={1}
                                            >
                                              <div
                                                className="cardcss"
                                                bis_skin_checked={1}
                                              >
                                                <img
                                                  className="card-img-top"
                                                  src="https://skyipay.co.uk/assets/images/photo/apple2.png"
                                                  alt="Step2"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <p>
                                            iii. Tap on Camera option and you
                                            will be navigated to CAMERA ACCESS
                                            ON ALL WEBSITES. Tap on "Allow"
                                            option.
                                          </p>
                                          <div
                                            className="row"
                                            bis_skin_checked={1}
                                          >
                                            <div
                                              className="col-12 col-md-5 col-lg-3"
                                              bis_skin_checked={1}
                                            >
                                              <div
                                                className="cardcss"
                                                bis_skin_checked={1}
                                              >
                                                <img
                                                  className="card-img-top"
                                                  src="https://skyipay.co.uk/assets/images/photo/apple3.png"
                                                  alt="Step1"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/*end col*/}
                                </div>
                                {/*end row*/}
                              </div>
                              {/*end teb pane*/}
                              <div
                                className="tab-pane fade active show"
                                id="android"
                                role="tabpanel"
                                aria-labelledby="pills-smart-tab"
                                bis_skin_checked={1}
                              >
                                <div
                                  className="row align-items-center"
                                  bis_skin_checked={1}
                                >
                                  <div
                                    className="col-md-12 mt-1 mt-sm-0 pt-0 pt-sm-0"
                                    bis_skin_checked={1}
                                  >
                                    <p>i. Go to Settings and tap on Apps</p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src="https://skyipay.co.uk/assets/images/photo/ad1.png"
                                            alt="Step1"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      ii. Scroll to find your default browser
                                      app. Mostly it is Google Chrome for
                                      Android device, unless explicitly changed.
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src="https://skyipay.co.uk/assets/images/photo/ad2.png"
                                            alt="Step2"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      iii. Chrome → Permissions will show you
                                      what is enabled. Camera permission need to
                                      be enabled here.{" "}
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src="https://skyipay.co.uk/assets/images/photo/ad3.png"
                                            alt="Step3"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      iv. App permissions will show what is
                                      allowed and what's denied.
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src="https://skyipay.co.uk/assets/images/photo/ad4.png"
                                            alt="Step4"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      v. Tap on Camera to Allow camera
                                      permission to Chrome.
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src="https://skyipay.co.uk/assets/images/photo/ad5.png"
                                            alt="Step5"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/*end col*/}
                                </div>
                                {/*end row*/}
                              </div>
                              {/*end teb pane*/}
                            </div>
                            {/*end tab content*/}
                          </div>
                          {/*end col*/}
                        </div>
                        {/*end row*/}
                      </div>
                    </div>
                  </li>
                  <li className="accordion block">
                    <div className="acc-btn" bis_skin_checked={1}>
                      <div className="icon-box" bis_skin_checked={1} />
                      <h4>
                        2. I'm getting error message saying, "Wrong ID document
                        or something went wrong..."{" "}
                      </h4>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{}}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>Does your screen look something like this?</p>
                        <div className="row" bis_skin_checked={1}>
                          <div
                            className="col-6 col-md-5 col-lg-3"
                            bis_skin_checked={1}
                          >
                            <div className="cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/ID Upload failure.png"
                                alt="Wrong ID document or something went wrong."
                              />
                            </div>
                          </div>
                        </div>
                        <p className="mt-2">
                          This means the ID you uploaded is not supported or was
                          having glare or blur while uploading. This may have
                          resulted us in not been able to capture ID details.
                          Please give it another try or contact our support
                          team.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>    
            </div>
          </div>
        </section>
      </div>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default OnboardingFAQ;
